<template>
  <div class="slider__text">
    <ul
      class="slider__text__list"
      :class="{ 'slider__text__list--transitions': showTransitions }"
      :style="`--dotcom-app-screens-index: ${currentIndex}`"
    >
      <li
        v-for="(slide, index) in slides"
        :key="index"
        class="slider__text__item"
        :class="{ 'slider__text__item--current': index === currentIndex }"
      >
        <h3 class="slider__text__title">{{ slide.textTitle }}</h3>
        <div class="slider__text__body san-richtext" v-html="slide.text"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DotcomSliderText',
  props: {
    slides: {
      type: Array,
      required: true,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    showTransitions: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="postcss">
.slider__text {
  width: var(--dotcom-app-screens-text-width);
  overflow: hidden;

  &__list {
    display: flex;
    list-style: none;
    height: 100%;

    transform: translateX(
      calc(
        var(--dotcom-app-screens-text-width) * var(--dotcom-app-screens-index) *
          -1
      )
    );

    ul {
      list-style-type: disc;

      ul {
        list-style-type: circle;
      }
    }

    &--transitions {
      transition: transform var(--dotcom-app-screens-transition-duration) ease;
    }
  }

  &__item {
    --dotcom-app-screen-transition-both: calc(
      var(--dotcom-app-screens-transition-duration) / 2
    );
    --dotcom-app-screen-transition-half: calc(
      var(--dotcom-app-screen-transition-both) / 3
    );

    width: var(--dotcom-app-screens-text-width);
    height: 100%;
    flex-shrink: 0;
    flex-grow: 0;

    /*
    These styles would fade out the text.
    But there is an issue with the loop and as the fade is not part of the
    requirements I disabled them. But I would like to keep them for later
    when I fix the looping issue.

    opacity: 0;
    transition: all var(--dotcom-app-screen-transition-both) ease;
    transition-delay: var(--dotcom-app-screen-transition-half);

    &--current {
      opacity: 1;
      transition-delay: 0;
      transition-duration: var(--dotcom-app-screen-transition-half);
    }
    */
  }

  &__title {
    font-weight: 700;
    font-size: 15px;
    line-height: 1.15;
  }

  &__body {
    display: block;
    overflow: auto;
    max-height: var(--dotcom-app-screens-text-max-height);
    font-size: 15px;
  }
}
</style>
